import { IPageInfo } from '../../../models/page.types';
import { ExamTaskGroupSolutionsProgressData } from '../../../pages/Assessment/Assessment.types';

export interface ExamTaskGroupSolutionsResponse {
  pageInfo: IPageInfo;
  list: List[];
  examinersHaveScoreToSendBack: { [examinerId: string]: boolean };
  progress: ExamTaskGroupSolutionsProgressData;
}

export interface List {
  tasksSolutionSheetId: string;
  examTaskGroupSolutionId: string;
  assessmentSessionProcessId: string;
  assessmentSessionProcessTypeId: AssessmentSessionProcessTypeId;
  examTaskGroupId: string;
  examinerId: string;
  status: Status;
  pointsSum: number;
  sampleAssessmentPoints: number | null;
  progress: number;
  downloadDate: Date;
  updateDate?: Date;
  examTaskGroupSolutionScoreId: string;
  isSpecialCase: boolean;
  examTaskNumbersWithNoAnswer: string[];
}

export enum Status {
  New,
  Open,
  Assessed,
  Closed,
}

export enum AssessmentSessionProcessTypeId {
  Training,
  Qualification,
  Scoring,
  Control,
}

export enum ExamTaskGroupSolutionStatus {
  Available,
  NoneExceededLimits,
  NoneNoMoreSolutions,
  NoneExaminerBlocked,
  NoneProcessFinished,
  NoneSessionClosed,
}

export const ExamTaskGroupSolutionStatusDisablingDownloading = [
  ExamTaskGroupSolutionStatus.NoneExaminerBlocked,
  ExamTaskGroupSolutionStatus.NoneProcessFinished,
  ExamTaskGroupSolutionStatus.NoneSessionClosed,
];

export const assessmentSessionProcessOrder: AssessmentSessionProcessTypeId[] = [
  AssessmentSessionProcessTypeId.Training,
  AssessmentSessionProcessTypeId.Qualification,
  AssessmentSessionProcessTypeId.Scoring,
];

export interface ExamTaskSolutionsIdResponse {
  examTaskGroupSolutions: ExamTaskGroupSolution[];
}

export interface ExamTaskGroupSolution {
  id: string;
  sheetId: string;
  examinerId?: string;
  examTaskGroupSolutionScoreId?: string;
}
